<template>
    <div class="root flex flex-col border-box">
        <my-table :fields="fields" :data="fileData" :opFields="opFields" @cellClick="cellClick" @cellChange="cellChange">
          <template slot="opField1" slot-scope="val">
              <span class="pointer color-blue"  @click="share(val.record)">分享</span>
              <span class="margin-left-l color-blue pointer" @click="more($event, val.record)">更多</span>
          </template>  
        </my-table>

        <popup-menu ref="child" :menuData="menuData"  @menuClick="menuClick" ></popup-menu>
        <Share :data="shareData"  :show="showShare" @close="showShare = false"></Share>
        <Move :dirData="dirData" :show="showMove" @close="showMove = false"></Move>

    </div>
</template>

<script>
    import PopupMenu from '@/components/popupMenu/PopupMenu' 
    import Share from '@/modules/share/Share'
    import Move from '@/modules/move/Move'
    import MyTable from '@/components/table/Table' 
    import {delDoc,updateDoc,getDoc,addDocShare} from '@/api/api.js';
    import {getShareToken} from '@/utils/sysUtils'
    import config from '@/config/index.js'
    import MixinDoc from '@/mixin/mixinDoc';

    
    export default{
        name:'DocTable',
        props:{
            fileData:{}

        },
        mixins:[MixinDoc],
        components:{
            PopupMenu,Share,Move,MyTable
        },
        watch:{
            fileData: {
                handler(newValue) {
                    this.tableData = newValue;
                    this.tableData.forEach(item => {
                        if (item.type == 1) {
                            item.typeName = '文件夹'
                        } else if (item.type == 2) {
                            item.typeName = '文件'
                        }                       
                    });
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                selectId: null,
                selectname: null,
                tableData: null,
                dirData: null,
                shareData: {},
                showShare: false, 
                showMove: false,
                fields: [
                    {title:'名称',fieldName:'name',width:'',canEdit: true},
                    {title:'类型',fieldName:'typeName',width:'150',canEdit: false},
                    {title:'创建时间',fieldName:'createTime',width:'15%',canEdit: false},
                    {title:'创建人',fieldName:'userName',width:'10%',canEdit: false}
                ],
                opFields : [
                    {name:'opField1', title:"操作", width:'10%'} 
                ]
            }
        },
        methods:{
            more(event, record) {
                this.selectId = record.id;
                this.selectName = record.name;
                this.$refs.child.show(event);//调用子组件的show方法，用于显示弹出式菜单，引用组件时，需要 ref="child"      
            },           
            cellClick(id, fieldName) {
                console.log("cellclick", id)
                this.$emit("itemClick", id);
            },
            cellChange(data) {
                updateDoc(data.id, data.name).then((res) => {
                    if (res.data.success == true) {
                        this.$closeInputBox();
                        this.$emit("change")
                    }
                });
            }
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/modules/doc/DocTable.vue